<template>
  <AsidePanel
    ref="asidePanel"
    cancelText="close"
    :components="components"
    :handleCancel="handleCancel"
    :handleSelectEvent="handleSelectEvent"
    :isExpanded="isExpanded"
    :itemId="itemId"
    :itemType="itemType"
    :redirectTo="directoryTypeRoute(itemType)"
    :showSaveButton="false"
    :viewport="viewport"
  >
    <template v-slot:avatar>
      <AsideIcon
        icon="workday"
      />
    </template>
  </AsidePanel>
</template>
<script>
import {
  DirectoryTypeConsts,
  ItemTypeConsts,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import AsideIcon from 'client/components/AsidePanel/AsideIcon.vue';
import AsidePanel from 'client/components/AsidePanel/AsidePanel.vue';
import AsidePanelPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelPropsMixin';
import WorkdayDetails from 'client/directories/Workday/WorkdayDetails.vue';
import WorkdayImportedUsersItemTable from 'client/directories/Workday/WorkdayImportedUserItemTable.vue';
import directoryRouteMixin from 'client/components/mixins/directoryRouteMixin';

const {
  directory,
  workday,
  workdayImportedUser,
} = ItemTypeConsts;

const directoryCollection = StoreModuleMap[directory];
const workdayModel = StoreModelMap[workday];
const workdayImportedUserCollection = StoreModuleMap[workdayImportedUser];

export default {
  name: 'WorkdayAsidePanel',

  components: {
    AsidePanel,
    AsideIcon,
  },

  mixins: [
    AsidePanelPropsMixin,
    directoryRouteMixin,
  ],

  props: {
    itemType: {
      type: String,
      default: workday,
      required: false,
    },
  },

  data() {
    const components = [{
      label: 'Details',
      vueComponent: WorkdayDetails,
    }, {
      label: this.importedUsersLabel,
      vueComponent: WorkdayImportedUsersItemTable,
      vueComponentProps: {
        parentBulkActionHandler() {
          this.viewport.redirect(this.directoryTypeRoute(DirectoryTypeConsts.workday));
        },
      },
    }];

    return {
      components,
      haveImportedUsersBeenViewed: false,
    };
  },

  computed: {
    ...mapGetters(workdayModel, [
      'hasItemChanged',
    ]),
  },

  beforeCreate() {
    // Add non-reactive constant data to component
    this.importedUsersLabel = 'Imported Users';
  },

  methods: {
    ...mapActions(directoryCollection, {
      refreshDirectories: 'refreshCollection',
    }),

    ...mapActions(workdayImportedUserCollection, {
      refreshWorkdayImportedUsers: 'refreshCollection',
    }),

    /**
     * Refresh the directories collection when the Workday Aside is closed so that if a new Workday
     * instance was created it will be visible in the Main Panel.
     */
    handleCancel() {
      this.refreshDirectories();
    },

    /**
     * When the Imported Users tab is clicked and it has already been viewed then refresh the
     * Workday Imported Users collection so that any recently imported users or changes to user
     * status are displayed when the admin navigates _back_ to the Imported Users tab. The admin
     * may have performed a Workday Import since first viewing Imported Users tab and new users will
     * not be displayed unless the collection is refreshed.
     */
    handleSelectEvent(label) {
      if (label === this.importedUsersLabel) {
        if (this.haveImportedUsersBeenViewed === false) {
          this.haveImportedUsersBeenViewed = true;
        } else {
          this.refreshWorkdayImportedUsers();
        }
      }
    },

    /**
     * @todo Consider moving some aspect of this method to the AsidePanel
     * component. Both the RadiusAsidePanel and UserAsidePanel have similar
     * functionality. However, the parent component _will_ need the ability to
     * supplement the base functionality. For example, in addition to checking
     * if the item has changed, the UserAsidePanel checks if the associations
     * or public keys have changed too.
     */
    hasModelChanged() {
      return this.hasItemChanged;
    },
  },
};
</script>
